import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { hostClass } from './EyeCatcher.styles.js';

var defaultProps = {
  fontSize: "medium"
};
var EyeCatcherPresentation = fComp(function (props) {
  var _cleanupClassObject, _cleanupClassObject2;

  var id = props.id,
      className = props.className,
      noMargin = props.noMargin,
      text = props.text,
      textLong = props.textLong,
      increaseWidth = props.increaseWidth,
      fontSize = props.fontSize,
      viewport = props.viewport,
      horizontalAlignment = props.horizontalAlignment; // tslint:disable-next-line:no-console
  // console.log(`Viewport:, ${viewport}`);

  return /*#__PURE__*/React.createElement(Host, {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__align-").concat(horizontalAlignment), true), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-text"), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-text-").concat(fontSize), true), _defineProperty(_cleanupClassObject2, "".concat(hostClass, "-text-wide"), increaseWidth), _cleanupClassObject2))
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "-text-inner")
  }, viewport === "xl" || viewport === "lg" && textLong ? textLong : text)));
}, defaultProps);

export { EyeCatcherPresentation, defaultProps };
